export const getResolvedWidth = indicatorWidth => Math.min(indicatorWidth, 100)
